// General
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { Modal } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import AdminUserForm from '../AdminUserForm';


import { closeAdminUserModal } from '../../../actions/siteadmin/modalActions';

import s from './AdminUserModal.css';
import messages from '../../../locale/jsonMessages';

class AdminUserModal extends Component {
  static defaultProps = {
    adminUserModalType: 'add'
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { closeAdminUserModal, adminUserModal, adminUserModalType, roles, paginationData, id, adminUserModalData } = this.props;

    return (
      <Modal show={adminUserModal} onHide={closeAdminUserModal} dialogClassName='commonModalContainer globalModalContainer'>
        <Modal.Header closeButton className='commonModalHeader'>
          <Modal.Title className='commonModalTitle'>
            {id ? <FormattedMessage  {...messages.editAdminUserLabel} /> : <FormattedMessage  {...messages.addAdminUserLabel} />}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass='commonModalBody'>
          <AdminUserForm roles={roles} paginationData={paginationData} initialValues={adminUserModalData} />
        </Modal.Body>
      </Modal>
    )
  }
}

const selector = formValueSelector('AdminUserForm');

const mapState = (state) => ({
  adminUserModal: state.adminModalStatus.adminUserModal,
  adminUserModalType: state.adminModalStatus.adminUserModalType,
  id: selector(state, 'id'),
  adminUserModalData: state.adminModalStatus.adminUserModalData
});

const mapDispatch = {
  closeAdminUserModal
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(AdminUserModal)));